/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationCategoryViewModelPrimeDatatableResults } from '../../models/navigation-category-view-model-prime-datatable-results';
import { PrimeDatatableParams } from '../../models/prime-datatable-params';

export interface ListNavigationCategories$Params {
      body?: PrimeDatatableParams
}

export function ListNavigationCategories(http: HttpClient, rootUrl: string, params?: ListNavigationCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListNavigationCategories.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationCategoryViewModelPrimeDatatableResults>;
    })
  );
}

ListNavigationCategories.PATH = '/api/Navigation/ListNavigationCategories';
